// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import { themr } from "react-css-themr";
import classnames from "classnames";
import {
  Button,
  // privileges
} from "@lifepay/rc-ui-toolkit";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
import { LOCK_KEYS } from "accessConfig";

// RELATIVE PATH IMPORTS
// importing default component styles
import CardStatusControl from "../controls/CardStatusControl";
import CardLimitsControl from "../controls/CardLimitsControl";
import CardContactsControl from "../controls/CardContactsControl";
import CardChangePinControl from "../controls/CardChangePinControl";
import CardResetPinCountControl from "../controls/CardResetPinCountControl";

import styles from "./CardsListControls.m.scss";

// const { LOCK_KEYS } = CLIENT_PRIVILEGES_CONFIG;

@themr("@lifepay/cards-list-controls", styles)
export default class CardsListControls extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    selectedCard: PropTypes.object,
    refetch: PropTypes.func,
    // features: PropTypes.shape({
    //   cardEdit: PropTypes.bool,
    // }),
  };

  constructor(props) {
    super(props);

    this.state = {};
  }

  activateCard = ({ activateCard }) => {};

  blockCard = ({ activateCard }) => {};

  render() {
    const { theme, selectedCard, refetch } = this.props;
    return selectedCard ? (
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.actions)}>
          <div className={classnames(theme.column)}>
            <CardStatusControl
              cardId={selectedCard.cardId}
              isValid={selectedCard.isValid}
              onSuccess={refetch}
            />
            <CardContactsControl
              cardId={selectedCard.cardId}
              onSuccess={refetch}
            />
          </div>
          <div className={classnames(theme.column)}>
            <CardChangePinControl
              cardId={selectedCard.cardId}
              onSuccess={refetch}
            />
            <CardResetPinCountControl
              cardId={selectedCard.cardId}
              onSuccess={refetch}
            />
          </div>
          <div className={classnames(theme.column)}>
            <CardLimitsControl cardId={selectedCard.cardId} />
          </div>
        </div>
        <div className={classnames(theme.footer)}>
          <Button
            type={"disabled"}
            size={"small"}
            onClick={() => {}} // stub
          >
            {"Другая проблема"}
          </Button>
          <Button
            type={"disabled"}
            size={"small"}
            onClick={() => {}} // stub
          >
            {"Другая проблема по карте"}
          </Button>
        </div>
      </div>
    ) : null;
  }
}



// WEBPACK FOOTER //
// ./src/components/emission/cards/CardsListControls/CardsListControls.js